(function () {
  function showToast(opts) {
    var host = document.getElementById('ThyredToastHost');
    if (!host) {
      host = document.createElement('div');
      host.id = 'ThyredToastHost';
      host.className = 'tr-toast-host';
      document.body.appendChild(host);
    }
    var toast = document.createElement('div');
    toast.className = 'tr-toast' + (opts.kind === 'error' ? ' is-error' : ' is-ok');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    var iconHtml = opts.kind === 'error'
      ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
    toast.innerHTML =
      '<div class="tr-toast-ic">' + iconHtml + '</div>' +
      '<div class="tr-toast-body">' +
        '<div class="tr-toast-t">' + (opts.title || '') + '</div>' +
        (opts.body ? '<div class="tr-toast-s">' + opts.body + '</div>' : '') +
      '</div>' +
      '<button type="button" class="tr-toast-x" aria-label="Dismiss">×</button>';
    host.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('in'); });
    var timer = setTimeout(close, opts.duration || 5000);
    function close() {
      clearTimeout(timer);
      toast.classList.remove('in');
      toast.classList.add('out');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }
    toast.querySelector('.tr-toast-x').addEventListener('click', close);
  }

  function emailValid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  var iframe, currentForm, currentEmail, loadCount, settled;

  function inspectIframe() {
    if (!iframe) return;
    var url = '', title = '', bodyText = '';
    try {
      url = iframe.contentWindow.location.href || '';
      var doc = iframe.contentDocument;
      title = (doc && doc.title) || '';
      bodyText = (doc && doc.body && doc.body.innerText) ? doc.body.innerText.slice(0, 400).toLowerCase() : '';
    } catch (e) {
      // Cross-origin redirect (e.g. to challenges.cloudflare) — we can't read it.
      // Treat as challenge so user can interact with it visually.
      url = '__opaque__';
    }
    var isChallenge =
      url.indexOf('/challenge') !== -1 ||
      url === '__opaque__' ||
      /captcha|robot|hcaptcha|recaptcha|challenge/.test(title.toLowerCase()) ||
      /not a robot|let us know you'?re not a robot|i am human|hcaptcha|recaptcha/.test(bodyText);
    return { url: url, title: title, isChallenge: isChallenge };
  }

  function onIframeLoad() {
    if (!iframe || settled) return;
    loadCount++;
    var info = inspectIframe();
    if (info.isChallenge) {
      // Captcha required — Shopify/Cloudflare won't render captchas inside an iframe
      // due to X-Frame-Options/CSP. Fall back: stash pending flag and natively
      // navigate the main page to the challenge so the user can solve it. On
      // return, init() detects the pending flag and fires the success toast.
      settled = true;
      try { sessionStorage.setItem('thyred-newsletter-pending', '1'); } catch (e) {}
      var challengeUrl;
      try { challengeUrl = iframe.contentWindow.location.href; } catch (e) {}
      if (challengeUrl && challengeUrl !== 'about:blank') {
        window.location.href = challengeUrl;
      } else {
        // Cross-origin iframe — re-submit form natively (no target) so the browser navigates
        if (currentForm) {
          currentForm.removeAttribute('target');
          currentForm.submit();
        }
      }
      return;
    }
    // Non-challenge response — Shopify accepted the form, redirected back.
    settled = true;
    showToast({
      title: 'You\'re in.',
      body: 'We\'ll email you product news and offers.',
      duration: 6000
    });
    if (currentForm) currentForm.reset();
    if (window.thyredTrackNewsletterSignup && currentEmail) {
      try { window.thyredTrackNewsletterSignup(currentEmail); } catch (err) {}
    }
    var btn = currentForm && currentForm.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-orig-label') || 'Notify me'; }
  }

  function handleSubmit(e) {
    var form = e.target.closest('.nl-form');
    if (!form) return;
    var emailEl = form.querySelector('input[type="email"]');
    var email = (emailEl && emailEl.value || '').trim();
    if (!emailValid(email)) {
      e.preventDefault();
      showToast({ kind: 'error', title: 'Please enter a valid email.', duration: 4000 });
      if (emailEl) emailEl.focus();
      return;
    }
    // The exit-intent popup carries its own iframe so its form never posts into
    // the bottom-of-page newsletter iframe (which scrolls the page to the bottom).
    var targetName = form.closest('#ThyredExitPopup') ? 'ThyredNewsletterPopupTarget' : 'ThyredNewsletterTarget';
    iframe = document.getElementById(targetName);
    if (!iframe) return; // Fallback to native page submit
    // Wire form to post into the hidden iframe so we don't navigate the main page
    form.setAttribute('target', targetName);
    currentForm = form;
    currentEmail = email;
    loadCount = 0;
    settled = false;
    iframe.removeEventListener('load', onIframeLoad);
    iframe.addEventListener('load', onIframeLoad);

    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.setAttribute('data-orig-label', btn.textContent);
      btn.disabled = true;
      btn.textContent = '…';
    }
    // Let the form submit natively into the iframe (no preventDefault).
  }

  function init() {
    document.addEventListener('submit', handleSubmit, true);
    // If returning from a Shopify captcha challenge, show the success toast.
    var pending = false;
    try { pending = sessionStorage.getItem('thyred-newsletter-pending') === '1'; } catch (err) {}
    var nativeOk = document.querySelector('.nl-msg.ok');
    if (nativeOk || pending) {
      try { sessionStorage.removeItem('thyred-newsletter-pending'); } catch (err) {}
      if (nativeOk) nativeOk.style.display = 'none';
      showToast({
        title: 'You\'re in.',
        body: 'We\'ll email you product news and offers.',
        duration: 6000
      });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
